import { ShefRosterStatus } from 'src/gqlReactTypings.generated.d';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { createSelectors } from './create-selectors';

interface State {
  shefRosterIndex: Record<string, ShefRosterStatus>;
  isShefRosterLoading: boolean;
}

interface Actions {
  updateShefRosterStats: (shefRoster: ShefRosterState[]) => void;
  getShefRosterForShefId: (shefId: string) => ShefRosterStatus;
  setShefRosterLoading: (isLoading: boolean) => void;
  getShefRosterLoading: () => boolean;
}

// Initialize a default state
export const INITIAL_STATE: State = {
  shefRosterIndex: {},
  isShefRosterLoading: false,
};

export const useShefRosterStore = create(
  persist(
    immer<State & Actions>((set, get) => ({
      ...INITIAL_STATE,
      updateShefRosterStats: (shefRoster: ShefRosterState[]): void => {
        const { shefRosterIndex } = get();
        const updatedShefRosterIndex = shefRoster.reduce(
          (accum, { shefId, status }) => {
            accum[shefId] = status;
            return accum;
          },
          { ...shefRosterIndex }
        );
        set({ shefRosterIndex: updatedShefRosterIndex });
      },
      getShefRosterForShefId: (shefId: string): ShefRosterStatus => {
        const { shefRosterIndex } = get();
        return shefRosterIndex[shefId];
      },
      setShefRosterLoading: (isLoading: boolean): void => {
        set({ isShefRosterLoading: isLoading });
      },
      getShefRosterLoading: (): boolean => {
        const { isShefRosterLoading } = get();
        return isShefRosterLoading;
      },
    })),
    {
      name: 'shef-roster-storage', // unique name
      getStorage: () => localStorage,
    }
  )
);

export const useShefRosterStoreSelectors = createSelectors(useShefRosterStore);

interface ShefRosterState {
  shefId: string;
  status: ShefRosterStatus;
}
